export default function Invalid(props) {
  return (
    <div className='logo-image-div'>
      <strong><p style={{ fontSize: "xx-large" }}>Invalid URL</p></strong>
    </div>
  )
}